import { ComputersAndVirtualMachinesController } from '../controller/ComputersAndVirtualMachinesController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { Filter } from '../../../grid/gridFilters/types';
import { ColumnKeys } from '../types';

export class ComputersAndVirtualMachinesWebComponent extends BaseWebComponentElement {
  public externalFilters: Filter<ColumnKeys>[] = [];

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ComputersAndVirtualMachinesController,
    });
  }
}
